import React from "react";

const CompanyName = () => {
  return <strong className="company-name">Belageri Technologies</strong>;
};

export default CompanyName;
